import airGoldBlackLogo from "../images/airGoldBlackLogo.svg";
import cvdBlackLogo from "../images/cvdBlackLogo.svg";
import koloroviBlackLogo from "../images/koloroviBlackLogo.svg";
import billionBlackLogo from "../images/billionBlackLogo.svg";
import reflectBlackLogo from "../images/reflectBlackLogo.svg";
import vidrodzennyaBlackLogo from "../images/vidrodzennyaBlackLogo.svg";
import harmonyBlackLogo from "../images/harmonyBlackLogo.svg";

export const INSTAGRAM_LINK = `https://www.instagram.com/direct/t/17845234668442133/#`;
export const INSTAGRAM_APP_LINK = `https://www.instagram.com/tsatsky.ukr`;
export const TELEGRAM_LINK = `https://t.me/tsatskyclub`;
export const PINTEREST_LINK = `https://ru.pinterest.com/tsatsky/`;

export const COLLECTIONS_DATA = [
    {
        name: "Air Gold",
        logoSrc: airGoldBlackLogo,
        alt: "Air Gold Logo",
        href: "/air-gold",
    },
    {
        name: "CVD Diamonds",
        logoSrc: cvdBlackLogo,
        alt: "CVD Diamonds Logo",
        href: "/diamonds",
    },
    {
        name: "Kolorovi Sapphires",
        logoSrc: koloroviBlackLogo,
        alt: "Kolorovi Sapphires Logo",
        href: "/kolorovi",
    },
    {
        name: "Billion",
        logoSrc: billionBlackLogo,
        alt: "Billion Logo",
        href: "/billion",
    },
    {
        name: "Reflect",
        logoSrc: reflectBlackLogo,
        alt: "Reflect Logo",
        href: "/reflect",
    },
    {
        name: "Відродження",
        logoSrc: vidrodzennyaBlackLogo,
        alt: "Відродження Logo",
        href: "/vidrodzhennya",
    },
    {
        name: "Harmony",
        logoSrc: harmonyBlackLogo,
        alt: "Harmony Logo",
        href: "/harmony",
    },
];
